import { useTheme } from 'antd-style'

import { RichEditorStoreProviderProps } from '@eastcoal/editor/Store/interface'
import {
  FONT_FAMILY_LIST,
  LINE_HEIGHT_LIST
} from '@eastcoal/editor/Store/store/constants'

export const useStoreConfig = () => {
  const theme = useTheme()

  return {
    defaultFontFamily: FONT_FAMILY_LIST[0].value,
    defaultFontSize: 16,
    defaultFontColor: theme.colorText,
    defaultFontBackgroundColor: '',
    defaultLineHeight: LINE_HEIGHT_LIST[0].value
  } as RichEditorStoreProviderProps
}
